import { window } from '../globals';

const isMobilePortrait = (): boolean =>
  window?.matchMedia('(max-width: 767px)').matches ?? false;
const isTabletPortrait = (): boolean =>
  window?.matchMedia('(max-width: 991px)').matches ?? false;
const isMobileLandscape = (): boolean =>
  window?.matchMedia(
    '(max-width: 1024px) and (max-height: 767px) and (orientation: landscape)',
  ).matches ?? false;
const isBreakpointLG = (): boolean =>
  window?.matchMedia('(min-width: 992px)').matches ?? false;

export {
  isMobilePortrait,
  isTabletPortrait,
  isMobileLandscape,
  isBreakpointLG,
};
